import { createSelector } from '@reduxjs/toolkit'

const getEmploymentSummary = (state) => state.employmentSummary

export default createSelector([getEmploymentSummary], (employmentSummary) => ({
    employmentSummary,
    employmentSummaryStatus: employmentSummary.status,
    hasEmploymentSummary: !!employmentSummary.taxReturnId,
}))
